import React from "react";
import { useConfirmationPrompt } from "~/components/confirmation-prompt";
import { EeCodeRecord } from "~/gql/types";
import { ValidationResponse } from "~/gql/types2";
import { useUpdateEeCodeActiveMutation } from "./UpdateEeCodeActive.hotchoc.generated";
import Button from "~/components/button";
import Spinner from "~/components/spinner";
import { toErrorMessage } from "~/validation-response-utils";
import { useSnackBar } from "~/components/snackbar";

type UpdateEeCodeActiveProps = {
  eeCode: EeCodeRecord;
  refresh: () => void;
};
export const UpdateEeCodeActive: React.FC<UpdateEeCodeActiveProps> = (
  props
) => {
  const { eeCode, refresh } = props;

  const prompt = useConfirmationPrompt();

  const [doUpdate, { loading }] = useUpdateEeCodeActiveMutation();

  const activeType = eeCode.isActive ? "inactive" : "active";

  const ucType = `${activeType[0].toUpperCase() + activeType.slice(1)}`;

  const addAlert = useSnackBar();

  const openPrompt = async () => {
    const promptResult = await prompt({
      cancelButtonText: `Don't mark ${activeType}`,
      confirmButtonText: `Yes, mark ${activeType}`,
      message: `Are you sure you want to mark this ee code ${activeType}?`,
      title: `Mark ${eeCode.eeCode} ${ucType}`,
    });

    if (promptResult !== "Confirm") {
      return;
    }

    const response = await doUpdate({
      variables: {
        input: {
          eeCode: eeCode.eeCode,
          isActive: !eeCode.isActive,
        },
      },
    });

    const result = response?.data?.eeCodes?.updateActive as ValidationResponse;

    const errorMessage = toErrorMessage(result);

    if (errorMessage) {
      addAlert({
        message: errorMessage,
        key: `${Math.random()}`,
        isSuccess: false,
      });

      return;
    }

    addAlert({
      isSuccess: true,
      key: `${Math.random()}`,
      message: `${eeCode.eeCode} marked ${activeType}`,
    });

    refresh();
  };
  return (
    <>
      <Button outlined onClick={openPrompt}>{`Mark ${ucType}`}</Button>
      <Spinner open={loading} />
    </>
  );
};
